import { render, staticRenderFns } from "./StowageInstructionView.vue?vue&type=template&id=8a63125e&scoped=true"
import script from "./StowageInstructionView.vue?vue&type=script&ts=true&lang=js"
export * from "./StowageInstructionView.vue?vue&type=script&ts=true&lang=js"
import style0 from "./StowageInstructionView.vue?vue&type=style&index=0&id=8a63125e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a63125e",
  null
  
)

export default component.exports